import React from 'react';
import SideFilter from './SideFilters/SideFilter';
import ImgComp from './ImgComponent/ImgComp';
import "./CategoryItemMain.css"
import { useState } from 'react';
import { useEffect } from 'react';
import Breadcrumb from './Breadcrumb/Breadcrumb';
import { Box } from '@mui/material';
import productDetalis from '../../json/product.json'
import SetLoader from '../loader/SetLoader';


const CategoryItemMain = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const [loading, setLoading] = useState(true)

  window.scrollTo({
    top: 0,
    behavior: "smooth"
    
});
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 950);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const steps = [
    { label: 'Home', url: '/' },
    { label: 'Shop' }
  ];
  useEffect(() => {

    const loadingTimeout = setTimeout(() => {
      setLoading(false);
    }, 1000);


    return () => clearTimeout(loadingTimeout);
  }, []);
 

  const prddata = productDetalis?.newPrd
  const categoryData = prddata.map((x) => x.prdcategory);
  const Categories = [...new Set(categoryData)];
  
  const jwelleryCaratsData = prddata.map((x) => x.jwelleryCarats);
  const CaratsData = [...new Set(jwelleryCaratsData)];
  
  const jwelleryColorData = prddata.map((x) => x.jwelleryColour);
  const ColorData = [...new Set(jwelleryColorData)];
  
  const jwelleryMaterialData = prddata.map((x) => x.jwelleryMaterial);
  const MaterialData = [...new Set(jwelleryMaterialData)];

  const diamontTypeData = prddata.map((x) => x.diamondType);
  const diamontData = [...new Set(diamontTypeData)];

  
  const allCategoryData = prddata.map((x)=>x.prdcategory)
  const [filter, setFilter] = useState({Categories,CaratsData,ColorData,MaterialData,diamontData,allCategoryData})
 
  const [openAccordions, setOpenAccordions] = useState([]);
  
  const [selectedFilters, setSelectedFilters] = useState({
      category: [],
      jewelryColor: [],
      jewelryMaterial: [],
      diamondType: [],
      jewelryCarat: []
  });
  
  const handleChangeFilter = (dataValue) => {
    setSelectedFilters(dataValue);
  }

  return (

    <div>
      {loading ? (
        <div>
          <Box className="flex justify-center items-center h-screen mt-16">
            <SetLoader />
          </Box>
        </div>
      ) : (
        <div>
          <div>
            <Breadcrumb steps={steps} />
          </div>
          <div className="flex">
            {isSmallScreen ? null : <SideFilter style={{ display: "block" }} openAccordions={openAccordions} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} filter={{ Categories, CaratsData, ColorData, MaterialData,diamontData ,allCategoryData}} setOpenAccordions={setOpenAccordions}/>}
            
            <ImgComp className="imgcomp ms-7" setOpenAccordions={setOpenAccordions} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} handleChangeFilter={handleChangeFilter} filter={filter}/>
          </div>
        </div>
      )}
    </div>

  );
};

export default CategoryItemMain;